import { useMemo } from "react";
import { TaskStatus } from "tm-shared/types";

interface TaskPayload {
    status: TaskStatus;
    comment?: string;
}

interface UseTaskCompletionParams {
    payloadMap: Record<string, TaskPayload> | undefined;
    expectedCount: number;
}

export const useTaskCompletion = ({
    payloadMap,
    expectedCount,
}: UseTaskCompletionParams) => {
    const isAllCompleted = useMemo(() => {
        if (!payloadMap) return false;

        const payloads = Object.values(payloadMap);

        if (expectedCount !== payloads.length) return false;

        for (const payload of payloads) {
            if (payload.status === TaskStatus.Incomplete) return false;

            if (payload.status === TaskStatus.Rejected && !payload.comment) {
                return false;
            }
        }

        return true;
    }, [payloadMap, expectedCount]);

    return { isAllCompleted };
};
